<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Problemas e/ou condições autorreferidas"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            sort-by="text"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        items() {
            return this.data.form.problemasCondicoesAutorreferidas.map(p => ({text: p}))
        }
    },
    data: () => ({
        fields: [{key: 'text', label: 'Problema/condição autorreferida', sortable: true}]
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>